import pageManager from "../../page";
import { ActionItem } from "../../types";
import Compose, { ACTION_LEVEL } from "../Compose";

export enum ACTION_ID {
    PAGE = 100,
    MODULE = 111,
    SUBMODULE = 112,
    ITEM = 101
}

export default class Expose extends Compose {
    compose(): ActionItem {
        if (this.pathNodes.length <= 0) {
            return null;
        }

        const { level, page, item } = this.extraActionItem();

        if (level === ACTION_LEVEL.PAGE) {
            if (page.exposed === true) {
                return null;
            }

            item.action_id = ACTION_ID.PAGE;

            pageManager.updateExposed(page.id);
        } else if (level === ACTION_LEVEL.MODULE) {
            item.action_id = ACTION_ID.MODULE;
        } else if (level === ACTION_LEVEL.SUBMODULE) {
            item.action_id = ACTION_ID.SUBMODULE;
        } else if (level === ACTION_LEVEL.ITEM) {
            item.action_id = ACTION_ID.ITEM;
        }

        return level === ACTION_LEVEL.UNKNOWN ? null : item;
    }
}
